import React from "react";
import { useState } from "react";
import { useContext } from "react";
import { StoreContext } from "../Context/StoreContext";
import { voteResource } from "../services/rooomService";
import Heart from "../VibehutUI/Icons/Heart";
import HeartFilled from "../VibehutUI/Icons/HeartFilled";
import { showLoginModal } from "../actions/uiModalActions";

function ResourceVote({ resourceId, isVoted: voted }) {
  const { state, dispatch } = useContext(StoreContext);
  const [isVoted, setIsVoted] = useState(voted);
  const {
    auth: { user },
  } = state;
  const handleVote = (voted) => {
    if (!user) {
      showLoginModal(dispatch);
      return;
    }
    if (user?.token) {
      setIsVoted(voted);
      voteResource(
        {
          resourceId: resourceId,
          isVoted: voted,
        },
        user?.token,
      )
        .then(() => {})
        .catch(() => {});
    }
  };

  return isVoted ? (
    <div
      onClick={() => handleVote(false)}
      style={{ minWidth: 36 }}
      className={`w-9 h-9 bg-frescoWhite rounded-full flex items-center justify-center cursor-pointer`}
    >
      <HeartFilled />
    </div>
  ) : (
    <div
      onClick={() => handleVote(true)}
      style={{ minWidth: 36 }}
      className={`w-9 h-9 bg-frescoWhite rounded-full flex items-center justify-center cursor-pointer`}
    >
      <Heart />
    </div>
  );
}

export default ResourceVote;
